export default __webpack_public_path__ + "static/hero-background-bff1d99e5182556b06fa0eecf720b6d6.png";